namespace $ {
	
	function batch< Host, Item >(
		host: Host,
		items: ( this: Host )=> Item[],
		task: ( this: Host, item: Item[] )=> void,
	) {

		items.call( host ) // track deps
		
		const skip = new Set< Item >()
		
		while( true ) {
			
			const snap = $mol_wire_sync( items ).call( host )
			const news = snap.filter( item => !skip.has( item ) )
			if( !news.length ) break
			
			$mol_wire_sync( task ).call( host, news )
			for( const item of news ) skip.add( item )

		}
		
	}

	export const $giper_baza_land_root = {
		data: new $giper_baza_link( '' ), // 0
		tine: new $giper_baza_link( 'AQAAAAAA' ), // 1
	}
	
	/** Standalone part of Glob which syncs separately, have own rights, and contains Units */
	export class $giper_baza_land extends $mol_object {
		
		/** Auth Independent actor with global unique id generated from Auth key */
		link() {
			return this.auth().pass().lord()
		}
		
		/** Auth Private key generated with Proof of Work  */
		auth() {
			return this.$.$giper_baza_auth.current()
		}
		
		faces = new $giper_baza_face_map
		
		tick() {
			return this.faces.tick( this.auth().pass().peer() )
		}

		_pass = new $mol_wire_dict< string /*Lord*/, $giper_baza_auth_pass >()
		_seal_item = new Map< string /*Lord*/, Map< string /*Item*/, $giper_baza_unit_seal > >()
		_seal_shot = new Map< string /*Shot*/, $giper_baza_unit_seal >()
		_gift = new $mol_wire_dict< string /*Lord*/, $giper_baza_unit_gift >()
		_sand = new $mol_wire_dict< string /*Head*/, $mol_wire_dict< string /*Lord*/, $mol_wire_dict< string /*Self*/, $giper_baza_unit_sand > > >()
		_unit_hash = new Map< string /*Hash*/, $giper_baza_unit_base >()
		
		pass_add( pass: $giper_baza_auth_pass ) {
			if( this._pass.has( pass.lord().str ) ) return
			this._pass.set( pass.lord().str, pass )
		}
		
		seal_add( seal: $giper_baza_unit_seal ) {
			
			const prev = this._seal_shot.get( seal.shot().str )
			if( prev ) return
			
			for( const hash of seal.hash_list() ) {
				
				const prev = this.seal_item_get( seal.lord(), hash )
				
				if( $giper_baza_unit_seal.compare( prev, seal ) <= 0 ) continue
				
				if( prev?.alive_items.has( hash.str ) ) {
					prev.alive_items.delete( hash.str )
					if( !prev.alive_items.size ) this.seal_del( prev )
					seal.alive_items.add( hash.str )
				}
				
				this.seal_item_set( seal, hash )
			}
			
			this._seal_shot.set( seal.shot().str, seal )
			
		}
		
		gift_add( gift: $giper_baza_unit_gift ) {
			
			const mate = gift.mate()
			
			const prev = this._gift.get( mate.str )
			if( $giper_baza_unit_gift.compare( prev, gift ) <= 0 ) return
			
			const peer = gift.lord().peer()
			
			if( prev ) this.gift_del( prev )
			this.faces.peer_summ_shift( peer.str, +1 )
			
			this._gift.set( mate.str, gift )
			this.faces.peer_time( peer.str, gift.time(), gift.tick() )
			
			this.unit_seal_inc( gift )
			
			if( ( prev?.rank() ?? $giper_baza_rank_deny ) > gift.rank() ) this.rank_audit()
			
		}
		
		sand_add( sand: $giper_baza_unit_sand ) {
			
			let peers = this._sand.get( sand.head().str )
			if( !peers ) this._sand.set( sand.head().str, peers = new $mol_wire_dict )
			
			let sands = peers.get( sand.lord().str )
			if( !sands ) peers.set( sand.lord().str, sands = new $mol_wire_dict )
			
			const prev = sands.get( sand.self().str )
			if( $giper_baza_unit_sand.compare( prev, sand ) <= 0 ) return
			
			const peer = sand.lord().peer()
			
			if( prev ) this.sand_del( prev )
			this.faces.peer_summ_shift( peer.str, +1 )
		
			sands.set( sand.self().str, sand )
			this._self_all.set( sand.self().str, !sand.dead() )
			
			this.faces.peer_time( peer.str, sand.time(), sand.tick() )
			
			this.unit_seal_inc( sand )
			
		}
		
		units_reaping = new Set< $giper_baza_unit_base >()
		
		unit_reap( unit: $giper_baza_unit_base ) {
			if( !this.mine().units_persisted.has( unit ) ) return
			this.units_reaping.add( unit )
		}
		
		unit_seal_inc( unit: $giper_baza_unit_base ) {
			
			unit._alive = true
			if( !unit.encoded() ) return
			
			this._unit_hash.set( unit.hash().str, unit )
			
			const seal = this.unit_seal( unit )
			if( !seal ) return
			
			seal.alive_items.add( unit.hash().str )
			
		}
		
		unit_seal_dec( unit: $giper_baza_unit_base ) {
			
			unit._alive = false
			
			if( !unit.encoded() ) return
			
			this._unit_hash.delete( unit.hash().str )
			
			const seal = this.unit_seal( unit )
			if( !seal ) return
			
			seal.alive_items.delete( unit.hash().str )
			
			if( !seal.alive_items.size ) this.seal_del( seal )
			
		}
		
		seal_del( seal: $giper_baza_unit_seal ) {
			
			const shot = seal.shot()
			if( !this._seal_shot.has( shot.str ) ) return
			
			this._seal_shot.delete( shot.str )
			
			for( const hash of seal.hash_list() ) {
				if( this.seal_item_get( seal.lord(), hash ) === seal ) {
					this.seal_item_del( seal.lord(), hash )
				}
			}
			
			this.unit_reap( seal )
			
		}
		
		gift_del( gift: $giper_baza_unit_gift ) {
			
			const prev = this._gift.get( gift.mate().str )
			if( prev !== gift ) return
			
			this._gift.delete( gift.mate().str  )
			this.faces.peer_summ_shift( gift.lord().peer().str, -1 )
			
			this.unit_reap( gift )
			this.unit_seal_dec( gift )
			
		}
		
		sand_del( sand: $giper_baza_unit_sand ) {
			
			const peers = this._sand.get( sand.head().str )
			if( !peers ) return
			
			const sands = peers.get( sand.lord().str )
			if( !sands ) return
			
			const prev = sands.get( sand.self().str )
			if( prev !== sand ) return
			
			sands.delete( sand.self().str )
			this.faces.peer_summ_shift( sand.lord().peer().str, -1 )
			
			this.unit_reap( sand )
			this.unit_seal_dec( sand )
			
		}
		
		@ $mol_mem_key
		lord_pass( lord: $giper_baza_link ) {
			return this._pass.get( lord.str ) ?? null
		}
		
		unit_seal( unit: $giper_baza_unit_base ) {
			
			if( !unit.encoded() ) return null
			
			return this.seal_item_get( unit.lord(), unit.hash() ) ?? null
			
		}
		
		seal_item_get( lord: $giper_baza_link, hash: $giper_baza_link ) {
			return this._seal_item.get( lord.str )?.get( hash.str )
		}
		
		seal_item_del( lord: $giper_baza_link, hash: $giper_baza_link ) {
			this._seal_item.get( lord.str )?.delete( hash.str )
		}
		
		seal_item_set( seal: $giper_baza_unit_seal, hash: $giper_baza_link ) {
			
			let seals = this._seal_item.get( seal.lord().str )
			if( !seals ) this._seal_item.set( seal.lord().str, seals = new Map )
			
			seals.set( hash.str, seal )
			
		}
		
		sand_get( head: $giper_baza_link, lord: $giper_baza_link, self: $giper_baza_link ) {
			return this._sand.get( head.str )?.get( lord.str )?.get( self.str ) ?? null
		}
		
		_self_all = new Map< string /*Self*/, boolean /*alive*/ >()
		
		/** Generates unique local id base on optional idea number or random. */
		@ $mol_action
		self_make( idea = Math.floor( Math.random() * 2**48 ) ): $giper_baza_link {
			
			const auth = this.auth()
			const rank = this.pass_rank( auth.pass() )
			
			if( rank < $giper_baza_rank_tier.post ) $mol_fail( new Error( `Rank too low (${ rank })` ) )
			
			for( let i = 0; i < 4096; ++i ) {
				
				idea = $mol_hash_numbers([ idea ])
				if( !idea ) continue
				
				const idea_link = $giper_baza_link.from_int( idea )
				if( /[æÆ]/.test( idea_link.str ) ) continue
				if( this._self_all.has( idea_link.str ) ) continue
				
				this._self_all.set( idea_link.str, false )
				return idea_link
				
			}
			
			$mol_fail( new Error( `Too long self generation` ) )
		}
		
		/** Makes new Area based on Idea or random. Once transfers rights from this Land. */
		@ $mol_action
		area_make( idea = Math.floor( $mol_wire_sync( Math ).random() * 2**48 ) ) {
			
			// this.saving()
			
			let id = ''
			while( true ) {
				
				idea = $mol_hash_numbers([ idea ])
				if( !idea ) continue
				
				id = $giper_baza_link.from_int( idea ).str
				if( /[æÆ]/.test( id ) ) continue
				
				break
			}
			
			const link = new $giper_baza_link( this.link().lord().str + '_' + id )
			
			const area = this.$.$giper_baza_glob.Land( link )
			
			area.inherit()
			area.bus()
			area.sync_mine()
			area.sync_yard()
			
			return area
		}
		
		@ $mol_mem
		sync_rights() {
			return new $mol_wire_atom( '', ()=> this.inherit() ).fresh()
		}
		
		@ $mol_mem
		inherit() {
			
			const area = this.link()
			const lord = this.link().lord()
			if( area.str === lord.str ) return
			
			const Lord = this.$.$giper_baza_glob.Land( lord )
			Lord.units_saving()
			
			const units = new Set< $giper_baza_unit >()
			
			for( const gift of Lord._gift.values() ) {
				
				const prev = $mol_wire_sync( this._gift ).get( gift.mate().str )
				if( $giper_baza_unit_gift.compare( prev, gift ) <= 0 ) continue
				
				const seal = Lord.unit_seal( gift )
				if( !seal ) continue
				
				units.add( gift )
				units.add( seal )
				units.add( Lord.lord_pass( gift.lord() )! )
				
				const mate = gift.mate()
				if( mate.str ) units.add( Lord.lord_pass( mate )! )
				
			}
			
			let part = $giper_baza_pack_part.from([ ... units ])
			const pack = $giper_baza_pack.make([[ this.link().str, part ]])
			
			part = pack.parts()[0][1]
			this.diff_apply( part.units )
			
		}
		
		/** Data root */
		@ $mol_mem_key
		Data< Pawn extends typeof $giper_baza_pawn >( Pawn: Pawn ) {
			return this.Pawn( Pawn ).Head( $giper_baza_land_root.data )
		} 
		
		/** Lands for inheritance */
		@ $mol_mem
		Tine() {
			return this.Pawn( $giper_baza_list_link ).Head( $giper_baza_land_root.tine ) 
		} 
		
		/** High level representation of stored data */
		@ $mol_mem_key
		Pawn< Pawn extends typeof $giper_baza_pawn >( Pawn: Pawn ): $giper_baza_fund< InstanceType< Pawn > > {
			return new $giper_baza_fund( ( head: $giper_baza_link )=> {
				return ( Pawn as typeof $giper_baza_pawn ).make({
					land: $mol_const( this ),//.sync(),
					head: $mol_const( head ),
				}) as InstanceType< Pawn >
			} )
		} 
		
		/** Total count of Units inside Land. */
		@ $mol_mem
		total() {
			
			let total = this._gift.size + this._seal_shot.size
			
			for( const peers of this._sand.values() ) {
				for( const units of peers.values() ) {
					total += units.size
				}
			}
			
			return total
		}
		
		@ $mol_mem
		king_pass() {
			return this.lord_pass( this.link().lord() )!
		}
		
		/** Rights level of Pass for Land. */
		@ $mol_mem_key
		pass_rank( pass: $giper_baza_auth_pass | null, next?: typeof $giper_baza_rank.Value ): typeof $giper_baza_rank.Value {
			
			const prev = this.lord_rank( pass?.lord() ?? null )
			
			if( next === undefined ) return prev
			if( next === prev ) return prev
			
			this.give( pass, next )
			return next
			
		}
		
		lord_tier( lord: $giper_baza_link ) {
			return $giper_baza_rank_tier_of( this.lord_rank( lord ) )
		}
		
		lord_rate( lord: $giper_baza_link ) {
			return $giper_baza_rank_rate_of( this.lord_rank( lord ) )
		}
		
		/** Rights level of Lord for Land. Works only when Pass for Lord exists in Land. */
		lord_rank( lord: $giper_baza_link | null, next?: typeof $giper_baza_rank.Value ) {
			
			if( lord?.str === this.link().lord().str ) return $giper_baza_rank_rule
			
			if( next === undefined ) {
				return this._gift.get( lord?.str ?? '' )?.rank()
					?? this._gift.get( $giper_baza_link.hole.str )?.rank()
					?? ( this.encrypted() ? $giper_baza_rank_deny : $giper_baza_rank_read )
				
			}
			
			const pass = lord ? this.lord_pass( lord ) : null
			// if( !pass ) $mol_fail( new Error( `No Pass for ${ lord }` ) )
			
			return this.pass_rank( pass, next )
			
		}
		
		/** Picks units between Face and current state. */
		diff_units( skip_faces = new $giper_baza_face_map ): $giper_baza_unit[] {
			
			this.units_signing()
			
			const skipped = new Map< string, Set< $giper_baza_unit_base > >()
			const delta = new Set< $giper_baza_unit_base >()
			const passes = new Set< $giper_baza_auth_pass >()
			const seals = new Set< $giper_baza_unit_seal >()
			
			function collect( unit: $giper_baza_unit_base ) {
				
				const peer = unit.lord().peer().str
				const face_limit = skip_faces.get( peer )?.time_tick ?? 0
				
				if( unit.time_tick() > face_limit ) return delta.add( unit )

				const skipped_units = skipped.get( peer )
				
				if( skipped_units ) skipped_units.add( unit )
				else skipped.set( peer, new Set([ unit ]) )
			
			}
			
			
			for( const gift of this._gift.values() ) {
				collect( gift )
				if( gift.mate().str ) {
					if( skip_faces.has( gift.lord().peer().str ) ) continue
					const mate_pass = this.lord_pass( gift.mate() )
					if( mate_pass ) passes.add( mate_pass )
				}
			}
			
			for( const kids of this._sand.values() ) {
				for( const peers of kids.values() ) {
					for( const sand of peers.values() ) {
						this.sand_load( sand )
						collect( sand )
					}
				}
			}
			
			// detect Unit absence and then restore all for Peer
			for( const [ peer, face ] of skip_faces ) {
				
				const skipped_units = skipped.get( peer )
				
				const skip_mass = skipped_units?.size ?? 0
				if( skip_mass <= face.summ ) continue
				
				$mol_wire_sync( this.$ ).$mol_log3_warn({
					place: this,
					message: 'Fail Summ',
					hint: 'Relax and wait for full peer resync',
					peer,
					skip_mass,
					peer_face: face,
					self_face: this.faces.get( peer ),
				})
				
				for( const unit of skipped_units! ) delta.add( unit )
				
			}
			
			for( const unit of delta ) {
				
				const seal = this.seal_item_get( unit.lord(), unit.hash() )
				
				if( seal ) seals.add( seal )
				else delta.delete( unit )
				
			}
			
			for( const unit of delta ) {
				
				if( skip_faces.has( unit.lord().peer().str ) ) continue
				
				const pass = this.lord_pass( unit.lord() )
				if( !pass ) return $mol_fail( new Error( 'No pass for lord' ) )
				
				passes.add( pass )
				
			}
			
			return [ ... passes, ... seals, ... delta ]
			
		}
		
		/** Picks units between Face and current state and make Part. */
		// @ $mol_action
		diff_part( skip_faces = new $giper_baza_face_map ): $giper_baza_pack_part {
			const units = this.diff_units( skip_faces )
			
			const faces = new $giper_baza_face_map
			for( const unit of units ) {
				
				const peer = unit.lord().peer()
				if( faces.has( peer.str ) ) continue
				
				const face = this.faces.get( peer.str )
				if( !face ) continue
				
				faces.set( peer.str, face.clone() )
				
			}
			
			return new $giper_baza_pack_part( units, faces )
		}
		
		/** Picks units between Face and current state and make Parts. */
		// @ $mol_action
		diff_parts( skip_faces = new $giper_baza_face_map ): $giper_baza_pack_parts {
			return [[ this.link().str, this.diff_part( skip_faces ) ]]
		}
		
		@ $mol_action
		face_pack(): $giper_baza_pack {
			return $giper_baza_pack.make([[
				this.link().str,
				new $giper_baza_pack_part( [], this.faces.clone() ),
			]])
		}
		
		/** Applies Diff to current state with verification. */
		@ $mol_action
		diff_apply( units: readonly $giper_baza_unit[], skip_load?: 'skip_load' ) {
			
			if( units.length === 0 ) return
			
			if( !skip_load ) this.loading()
			
			units = $mol_wire_sync( this.$ ).$giper_baza_unit_sort( units )
			
			const passes = new Map< string/*Lord*/, $giper_baza_auth_pass >()
			
			const mixin_area = this.link().toBin()
			const mixin_lord = this.link().lord().toBin()
			
			for( const unit of units ) {
				if( unit instanceof $giper_baza_auth_pass ) {
					passes.set( unit.hash().str, unit )
				}
			}
			
			for( const unit of units ) if( unit instanceof $giper_baza_unit_seal ) {
				
				const lord_pass = this.lord_pass( unit.lord() ) ?? passes.get( unit.lord().str )
				if( !lord_pass ) return this.$.$mol_fail( new Error( `No Pass for Lord`, { cause: unit.lord() } ) )
				
				if( this.$.$giper_baza_unit_trusted_check( unit ) ) continue
				
				const mixin = unit.wide() ? mixin_lord : mixin_area
				const sens = unit.shot().mix( mixin )
				
				const checked = $mol_wire_sync( lord_pass.auditor() ).verify( sens, unit.sign() )
				if( !checked ) return $mol_fail( new Error( `Wrong Sign` ) )
				
			}
			
			for( const unit of units ) {
				if( unit instanceof $giper_baza_unit_seal ) {
					$giper_baza_unit_trusted_grant( unit )
				}
			}
			
			for( const unit of units ) {
				
				if( unit instanceof $giper_baza_auth_pass ) continue
				
				if( this.lord_tier( unit.lord() ) < unit.tier_min() ) {
					this.$.$mol_log3_warn({
						message: 'Too low Tier',
						tier_min: unit.tier_min().toString(2),
						tier_actual: this.lord_tier( unit.lord() ).toString(2),
						hint: 'Relax. Unit is skipped.',
						place: `${this}.diff_apply()`,
					})
					continue
				}
				
				const lord_pass = this.lord_pass( unit.lord() ) ?? passes.get( unit.lord().str )
				if( !lord_pass ) return this.$.$mol_fail( new Error( `No Pass for Lord`, { cause: unit.lord() } ) )
				
				switch( unit.kind() ) {
					
					case 'seal': {
						
						const seal = unit as $giper_baza_unit_seal
						
						if( this.lord_rate( unit.lord() ) < seal.rate_min() ) {
							return this.$.$mol_fail( new Error( 'Too low Rate' ) )
						}
				
						this.seal_add( seal )
						
						break
					}
					
					case 'gift': {
						
						const gift = unit as $giper_baza_unit_gift
						
						if( !this.$.$giper_baza_unit_trusted_check( gift ) ) {
							const seal = this.unit_seal( gift )
							if( !seal ) return this.$.$mol_fail( new Error( `No Seal for Gift`, { cause: gift } ) )
						}
						
						if( gift.mate().str ) {
							
							const mate_pass = this.lord_pass( gift.mate() ) ?? passes.get( gift.mate().str )
							if( !mate_pass ) return this.$.$mol_fail( new Error( `No Pass for Mate`, { cause: gift } ) )
							
							this.pass_add( mate_pass )
							
						}
						
						this.gift_add( gift )
						
						break
					}
					
					case 'sand': {
						
						const sand = unit as $giper_baza_unit_sand
						
						if( !this.$.$giper_baza_unit_trusted_check( sand ) ) {
							const seal = this.unit_seal( sand )
							if( !seal ) return this.$.$mol_fail( new Error( `No Seal for Sand`, { cause: sand } ) )
						}
						
						this.sand_add( sand )
						
						break
					}
					
					default: {
						return this.$.$mol_fail( new Error( `Unsupported Kind` ) )
					}
					
				}
				
				this.pass_add( lord_pass )
				
			}
			
			return units
		}
		
		@ $mol_action
		units_steal( donor: $giper_baza_land ) {
			this.diff_apply( donor.diff_units(), 'skip_load' )
		}
		
		rank_audit() {
			
			start: while( true ) {
			
				for( const [ shot, seal ] of this._seal_shot ) {
					
					const rank = this.lord_rank( seal.lord() )
					if( rank >= seal.rank_min() ) continue
					
					this.seal_del( seal )
					
				}
				
				for( const [ lord, gift ] of this._gift ) {
					
					// if( this.unit_seal( gift ) ) {
						const tier = this.lord_tier( gift.lord() )
						if( tier >= gift.tier_min() ) continue
					// }
					
					this.gift_del( gift )
					
					continue start
				}
				
				for( const [ head, peers ] of this._sand ) {
					for( const [ peer, sands ] of peers ) {
						for( const [ self, sand ] of sands ) {
							
							const tier = this.lord_tier( sand.lord() )
							if( tier >= sand.tier_min() ) continue
							
							this.sand_del( sand )
							
						}
					}
				}
			
				break
			}
			
		}
		
		@ $mol_action
		fork( preset: $giper_baza_rank_preset = [[ null, $giper_baza_rank_read ]] ) {
			const land = this.$.$giper_baza_glob.land_grab( preset )
			land.Tine().items_vary([ this.link() ])
			return land
		}
		
		@ $mol_mem_key
		sand_ordered( { head, peer }: { head: $giper_baza_link, peer: $giper_baza_link | null } ) {
			
			this.sync()
			// this.secret() // early async to prevent async on put
			
			const queue = ( peer?.str )
				? [ ... this._sand.get( head.str )?.get( peer!.str )?.values() ?? [] ]
				: [ ... this._sand.get( head.str )?.values() ?? [] ].flatMap( units => [ ... units.values() ] )
			
			const slices = new Map
			for( const sand of queue ) slices.set( sand, 0 )
			
			merge: if( head.str !== $giper_baza_land_root.tine.str ) {
				
				const tines = ( this.Tine()?.items_vary().slice().reverse() ?? [] )
					.map( val => $giper_baza_link_schema.cast( val ) )
					.filter( $mol_guard_defined )
				if( !tines.length ) break merge
				
				const exists = new Set( queue.map( sand => sand.self().str ) )
				
				const glob = this.$.$giper_baza_glob
				let slice = 0
				for( const link of tines ) {
					++ slice
					const land = glob.Land( link )
					for( const sand of land.sand_ordered({ head, peer }) ) {
						
						if( exists.has( sand.self().str ) ) continue
						queue.push( sand )
						exists.add( sand.self().str )
						slices.set( sand, slice )
						
					}
					
				}
				
			}
			
			if( queue.length < 2 ) return queue
			
			const compare = ( left: $giper_baza_unit_sand, right: $giper_baza_unit_sand )=> {
				return ( slices.get( left ) - slices.get( right ) ) || $giper_baza_unit_sand.compare( left, right )
			}
			
			queue.sort( compare )
			
			let entry = {
				sand: null as null | $giper_baza_unit_sand,
				next: null as null | string,
				prev: null as null | string,
			}
			
			const key = peer === null ? ( sand: $giper_baza_unit_sand )=> sand.path() : ( sand: $giper_baza_unit_sand )=> sand.self().str
			
			const by_key = new Map([ [ entry.prev, entry  ] ])
			const by_self = new Map([ [ entry.prev, entry ] ])
			
			while( queue.length ) {
				
				const last = queue.pop()!
				by_key.get( entry.prev )!.next = key( last )
				
				const item = { sand: last, next: null, prev: entry.prev }
				by_key.set( key( last ), item )
				
				const exists = by_self.get( last.self().str )
				if( !exists || compare( exists.sand!, last ) < 0 ) {
					by_self.set( last.self().str, item )
				}
				
				entry.prev = key( last )
				
				for( let cursor = queue.length - 1; cursor >= 0; --cursor ) {
					
					const kid = queue[cursor]
					
					let lead = by_self.get( kid.lead().str || null )
					if( !lead ) continue
					
					while( lead.next && ( compare( by_key.get( lead.next )!.sand!, kid ) < 0 ) ) lead = by_key.get( lead.next )!
					
					const exists1 = by_key.get( key( kid ) )
					if( exists1 ) {
						
						if( ( lead.sand ? key( lead.sand ) : null ) === exists1.prev ) {
							exists1.sand = kid
							if( cursor === queue.length - 1 ) queue.pop()
							continue
						}
						
						by_key.get( exists1.prev )!.next = exists1.next
						by_key.get( exists1.next )!.prev = exists1.prev
						
					}
					
					const follower = by_key.get( lead.next )!
					follower.prev = key( kid )
					
					const item = { sand: kid, next: lead.next, prev: lead.sand ? key( lead.sand ) : null }
					by_key.set( key( kid ), item )
					
					const exists2 = by_self.get( kid.self().str )
					if( !exists2 || compare( exists2.sand!, kid ) < 0 ) {
						by_self.set( kid.self().str, item )
					}
					
					lead.next = key( kid )
					
					if( cursor === queue.length - 1 ) queue.pop()
					cursor = queue.length
					
				}
				
			}
			
			const res = [] as $giper_baza_unit_sand[]
			
			while( entry.next !== null ) {
				entry = by_key.get( entry.next )!
				res.push( entry.sand! )
			}
			
			return res
		}
		
		@ $mol_mem
		@ $mol_action
		join() {
			this.encrypted( this.encrypted() )
		}
		
		/**
		 * Gives access rights to Lord by Auth key.
		 * `null` - gives rights for all Peers.
		 */
		@ $mol_action
		give(
			mate_pass: $giper_baza_auth_pass | null,
			rank: typeof $giper_baza_rank.Value,
		) {
			
			this.join()
			
			const gift = $giper_baza_unit_gift.make()
			const lord_pass = this.auth().pass()
			
			gift._land = this
			
			gift.lord( lord_pass.lord() )
			gift.rank( rank )
			gift.time_tick( this.tick().time_tick )
			
			if( mate_pass ) gift.mate( mate_pass.lord() )
			
			if( rank >= $giper_baza_rank_read ) {
				
				const secret_land = this.secret()
				if( secret_land ) {
					
					if( !mate_pass ) return $mol_fail( new Error( `Encrypted land can't be shared to everyone` ) )
					
					const secret_mutual = this.auth().secret_mutual( mate_pass )
					if( secret_mutual ) {
						const salt = $mol_buffer.from( gift.salt().slice() ).mix( this.link().lord().toBin() )
						const code = $mol_wire_sync( secret_mutual ).close( secret_land, salt )
						gift.code().set( code )
					}
					
				}
				
			} else {
				if( !this.encrypted() ) $mol_fail( new Error( 'Unencrypted Land is always public' ) )
			}
			
			$giper_baza_unit_trusted_grant( gift )
			
			this.diff_apply( [ lord_pass, ... $mol_maybe( mate_pass ), gift ] )
			
			this.broadcast()
			
			return gift
		}
		
		/** Places data to tree. */
		@ $mol_action
		post(
			lead: $giper_baza_link,
			head: $giper_baza_link,
			self: $giper_baza_link | null,
			vary: $giper_baza_vary_type,
			tag: keyof typeof $giper_baza_unit_sand_tag = 'term',
		) {
			
			this.join()
			
			const lord_pass = this.auth().pass()
			const encrypted = vary === null ? false : this.encrypted()
			
			let open = $giper_baza_link_base( this.link(), ()=> $giper_baza_vary.pack([ vary ]) )
			
			const length = encrypted ? Math.ceil( ( open.byteLength + 1 ) / 16 ) * 16 : open.byteLength
			const sand = $giper_baza_unit_sand.make( length, tag )
			
			sand._open = open
			sand._land = this
			
			$giper_baza_unit_trusted_grant( sand )
			
			sand.time_tick( this.tick().time_tick )
			sand.lord( lord_pass.lord() )
			sand.lead( lead )
			sand.head( head )
			sand._vary = vary
			
			sand.self( self ?? this.self_make( encrypted ? undefined : $mol_hash_numbers( open, sand.idea_seed() ) ) )
			
			this.diff_apply( [ lord_pass, sand ] )
			
			this.broadcast()
			return sand
		}
		
		@ $mol_action
		sand_move(
			sand: $giper_baza_unit_sand,
			head: $giper_baza_link,
			seat: number,
			peer = $giper_baza_link.hole as $giper_baza_link | null
		) {
			
			if( sand.dead()  ) $mol_fail( new RangeError( `Can't move wiped sand` ) )
			
			const units = this.sand_ordered({ head, peer }).filter( unit => !unit.dead() )
			if( seat > units.length ) $mol_fail( new RangeError( `Seat (${seat}) out of units length (${units.length})` ) )
			
			const lead = seat ? units[ seat - 1 ].self() : $giper_baza_link.hole
			const vary = this.sand_decode( sand )
			
			if( sand.head() === head ) {
				
				const seat_prev = units.indexOf( sand )
				
				if( seat === seat_prev ) return
				if( seat === seat_prev + 1 ) return
				
				const prev = seat_prev ? units[ seat_prev - 1 ].self() : $giper_baza_link.hole
				const next = units[ seat_prev + 1 ]
				
				if( next ) this.post(
					prev,
					head,
					next.self(),
					this.sand_decode( next ),
					next.tag(),
				)
				
			} else {
				
				this.sand_wipe( sand )
				
			}
			
			return this.post(
				lead,
				head,
				sand.self(),
				vary,
				sand.tag(),
			)
			
		}
		
		@ $mol_action
		sand_wipe(
			sand: $giper_baza_unit_sand,
			peer = $giper_baza_link.hole as $giper_baza_link | null
		) {
			
			const head = sand.head()
			const units = this.sand_ordered({ head, peer }).filter( unit => !unit.dead() )
			const seat = units.indexOf( sand )
			if( seat < 0 ) return sand
			
			return this.post(
				seat ? units[ seat - 1 ].self() : $giper_baza_link.hole,
				head,
				sand.self(),
				null,
				'term',
			)
			
		}
		
		broadcast() {
			this.persisted( true )
			this.$.$giper_baza_glob.yard().lands_news.add( this.link().str )
		}
		
		@ $mol_mem
		sync() {
			this.loading()
			this.sync_rights()
			this.bus()
			this.sync_mine()
			this.sync_yard()
			return this
		}
		
		destructor() {
			Promise.resolve().then( ()=> {
				this.$.$giper_baza_glob.yard().forget_land( this )
			} )
		}
		
		@ $mol_mem
		mine() {
			$mol_wire_solid()
			return this.$.$giper_baza_mine.land( this.link() )
		}
		
		@ $mol_mem
		sync_mine() {
			return new $mol_wire_atom( '', ()=> this.units_saving() ).fresh()
		}
		
		@ $mol_mem
		sync_yard() {
			const root = new $mol_wire_atom( 'sync_yard', ()=> this.$.$giper_baza_glob.yard().sync_land( this.link() ) )
			setTimeout( ()=> root.fresh() )
			return root
		}
		
		@ $mol_mem
		bus() {
			return new this.$.$mol_bus< ArrayBuffer >(
				`$giper_baza_land:${ this.link() }`,
				$mol_wire_async( buf => {
					
					const pack = new $giper_baza_pack( buf )
					const part = new Map( pack.parts() ).get( this.link().str )!
					
					for( const unit of part.units ) {
						$giper_baza_unit_trusted_grant( unit )
						this.mine().units_persisted.add( unit )
					}
					
					this.diff_apply( part.units )
					
				} ),
			)
		}
		
		@ $mol_mem
		loading() {
			$mol_wire_solid()
			
			let units = $mol_wire_sync( this.mine() ).units_load()
			if( units.length ) this.persisted( true )
			
			if( this.$.$giper_baza_log() ) $mol_wire_sync( this.$ ).$mol_log3_rise({
				place: this,
				message: 'Load Unit',
				units: units,
			})
			
			$mol_wire_sync( this ).diff_apply( units, 'skip_load' )
			
		}
		
		@ $mol_mem
		sands_unencoded() {
			
			const sands = [] as $giper_baza_unit_sand[]
			
			for( const kids of this._sand.values() ) {
				for( const units of kids.values() ) {
					for( const sand of units.values() ) {
						
						if( sand._vary === undefined ) continue
						if( sand._ball ) continue
						
						sands.push( sand )
						
					}
				}
			}
			
			return sands
		}
		
		@ $mol_mem
		sand_encoding() {
			this.loading()
			batch( this, this.sands_unencoded, this.sands_encode )
		}
		
		@ $mol_mem
		units_unsigned() {
			
			const signing = [] as $giper_baza_unit_base[]
			
			for( const gift of this._gift.values() ) {
				if( this.unit_seal( gift ) ) continue
				signing.push( gift )
			}
			
			for( const kids of this._sand.values() ) {
				for( const units of kids.values() ) {
					for( const sand of units.values() ) {
						if( this.unit_seal( sand ) ) continue
						signing.push( sand )
					}
				}
			}
			
			return signing
		}
		
		@ $mol_mem
		units_signing() {
			this.sand_encoding()
			batch( this, this.units_unsigned, this.units_sign )
		}
		
		@ $mol_mem
		units_unsaved() {
			
			const mine = this.mine()
			const persisting = new Set< $giper_baza_unit >()
			
			const check_lord = ( lord: $giper_baza_link )=> {
				
				const pass = this.lord_pass( lord )
				if( !pass ) return
				
				if( mine.units_persisted.has( pass ) ) return
				
				persisting.add( pass )
				
			}
			
			for( const gift of this._gift.values() ) {
				
				if( mine.units_persisted.has( gift ) ) continue
				
				persisting.add( gift )
				check_lord( gift.lord() )
				check_lord( gift.mate() )
				
			}
			
			for( const kids of this._sand.values() ) {
				for( const units of kids.values() ) {
					for( const sand of units.values() ) {
						
						if( $mol_wire_sync( mine.units_persisted ).has( sand ) ) continue
						
						persisting.add( sand )
						check_lord( sand.lord() )
						
					}
				}
			}
			
			for( const seal of this._seal_shot.values() ) {
				
				if( !seal.alive_items.size ) continue
				if( mine.units_persisted.has( seal ) ) continue
				
				persisting.add( seal )
				
			}
			
			return [ ... persisting ]
		}
		
		@ $mol_mem
		units_saving() {
			this.units_signing()
			if( !this.persisted() ) return
			batch( this, this.units_unsaved, this.units_save )
		}
		
		async units_save( units: readonly $giper_baza_unit[] ) {
			
			const mine = this.mine()
			
			const reaping = [ ... this.units_reaping ]
			this.units_reaping.clear()
			
			await $mol_wire_async( mine ).units_save({ ins: units, del: reaping })
			
			const part = new $giper_baza_pack_part( units )
			const pack = $giper_baza_pack.make([[ this.link().str, part ]])
			this.bus().send( pack.buffer )
			
			if( this.$.$giper_baza_log() ) this.$.$mol_log3_done({
				place: this,
				message: 'Save Unit',
				ins: units,
				del: reaping,
			})
			
		}
		
		@ $mol_mem
		persisted( next?: boolean ): boolean {
			
			$mol_wire_solid()
			
			if( next !== undefined ) return next
			
			const level = $mol_wire_sync( this.$.$mol_storage ).level()
			if( level <= 0 ) return true
			if( level > 6 ) return false
			
			const crop = 8 - level
			
			const self = this.auth().pass().lord().toBin().at(-1)!
			const land = this.link().toBin().at(-1)!
			
			return ( self >>> crop )===( land >>> crop )
			
		}
		
		async units_sign( units: readonly $giper_baza_unit_base[] ) {
			
			await Promise.resolve() // prevent deps
			
			const lands = new Map< $giper_baza_land, $giper_baza_link[] >()
			for( const unit of units ) {
				
				if( !unit._land ) continue
				let us = lands.get( unit._land! )
				if( us ) us.push( unit.hash() )
				else lands.set( unit._land!, [ unit.hash() ] )
				
			}
			
			const me = this.auth().pass().lord().str
			for( const seal of this._seal_shot.values() ) {
				
				if( seal.alive_full() ) continue
				if( seal.lord().str !== me ) continue
				
				seal._land ??= this
				let us = lands.get( this )
				if( !us ) lands.set( seal._land, us = [] )
				
				const hashes = seal.alive_list()
				us.push( ... hashes )
				
				// this.seal_del( seal )
			}
			
			const threads = [ ... lands.entries() ].flatMap( ([ land, hashes ])=> {
				
				const auth = land.auth()
				const rate = $giper_baza_rank_rate_of( land.pass_rank( auth.pass() ) )
				const wide = ! land.link().area().str
				
				return $mol_array_chunks( hashes, $giper_baza_unit_seal_limit ).map( async( hashes )=> {
				
					const seal = $giper_baza_unit_seal.make( hashes.length, wide )
					
					seal.lord( auth.pass().lord() )
					seal.hash_list( hashes )
					seal._land = this
					
					do {
						
						seal.time_tick( this.tick().time_tick )
						const sens = seal.shot().mix( this.link() )
						
						const sign = await auth.signer().sign( sens )
						seal.sign( sign )
						
					} while( seal.rate_min() > rate )
					
					return seal
				} )
				
			} )
			
			const seals = await Promise.all( threads )
			for( const seal of seals ) {
				for( const hash of seal.hash_list() ) {
					if( this._unit_hash.has( hash.str ) ) {
						seal.alive_items.add( hash.str )
					}
				}
				if( seal.alive_items.size ) this.seal_add( seal )
			}
			
			return seals
		}
		
		sands_encode( sands: readonly $giper_baza_unit_sand[] ) {
			return Promise.all( sands.map( sand => this.sand_encode( sand ) ) )
		}
		
		async sand_encode( sand: $giper_baza_unit_sand ) {
			
			let bin = sand._open
			
			if( sand._vary !== null ) {
				const secret = sand._land!.secret()!
				if( secret ) {
					const salt = $mol_buffer.from( sand.salt().slice() ).mix( this.link().toBin() )
					bin = await secret.encrypt( bin!, salt )
				}
			}
			
			sand.ball( bin! )
			
			if( sand._alive ) this._unit_hash.set( sand.hash().str, sand )
			
			return sand
		}
		
		@ $mol_mem_key
		sand_load( sand: $giper_baza_unit_sand ) {
			if( sand._ball ) return
			sand._ball = sand.big() ? $mol_wire_sync( this.mine() ).ball_load( sand ) : sand.data()
		}
		
		@ $mol_mem_key
		sand_decode( sand: $giper_baza_unit_sand ): $giper_baza_vary_type {
			
			try {
				// const open = this.sand_decrypt( sand )
				const open = sand._open!
				return $giper_baza_link_base( this.link(), ()=> ( $giper_baza_vary.take( open ) as any )[0] )
			} catch( error ) {
				
				if( error instanceof Promise ) return $mol_fail_hidden( error )
				this.$.$mol_fail_log( error )
				return null

			}

		}
		
		// @ $mol_mem_key
		// sand_decrypt( sand: $giper_baza_unit_sand ): Uint8Array< ArrayBuffer > {
			
		// 	if( this.sand_get( sand.head(), sand.lord(), sand.self() ) !== sand ) {
		// 		for( const id of this.Tine().items_vary() ?? [] ) {
		// 			const open = this.$.$giper_baza_glob.Land( $giper_baza_vary_cast_link( id! )! ).sand_decrypt( sand )
		// 			if( open ) return open
		// 		}
		// 		return undefined!
		// 	}
			
		// 	const secret = this.secret()
			
		// 	if( sand._open ) return sand._open
			
		// 	if( !sand._ball ) sand._ball = sand.big() ? $mol_wire_sync( this.mine() ).ball_load( sand ) : sand.data()
		// 	if( secret && sand._ball && !sand.dead() ) {
		// 		try {
		// 			sand._open = $mol_wire_sync( secret ).decrypt( sand._ball, sand.salt() )
		// 		} catch( error: any ) {
		// 			if( $mol_fail_catch( error ) ) {
		// 				if( error.message ) $mol_fail_hidden( error )
		// 				else $mol_fail_hidden( new Error( `Can't decrypt`, { cause: error } ) )
		// 			}
		// 		}
		// 	} else {
		// 		sand._open = sand._ball
		// 	}
			
		// 	return sand._open!
			
		// }
		
		@ $mol_action
		sands_open( sands: readonly $giper_baza_unit_sand[] ) {
			const encrypted = this.encrypted()
			const closed = sands.filter( sand => {
				if( sand._open ) return false
				if( !sand._ball ) {
					if( sand.big() ) return true
					sand._ball = sand.data()
				}
				if( encrypted && !sand.dead() ) return true
				sand._open = sand._ball
			} )
			if( !closed.length ) return
			return Promise.all( closed.map( sand => this.sand_open( sand ) ) )
		}
		
		async sand_open( sand: $giper_baza_unit_sand ): Promise< Uint8Array< ArrayBuffer > > {
			
			if( this.sand_get( sand.head(), sand.lord(), sand.self() ) !== sand ) {
				for( const id of this.Tine().items_vary() ?? [] ) {
					const open = await this.$.$giper_baza_glob.Land( $giper_baza_link_schema.cast( id! )! ).sand_open( sand )
					if( open ) return open
				}
				return undefined!
			}
			
			const secret = this.secret()
			
			if( sand._open ) return sand._open
			
			if( !sand._ball ) sand._ball = sand.big() ? await $mol_wire_async( this.mine() ).ball_load( sand ) : sand.data()
			if( secret && sand._ball && !sand.dead() ) {
				const salt = $mol_buffer.from( sand.salt().slice() ).mix( this.link().toBin() )
				try {
					sand._open = await secret.decrypt( sand._ball, salt )
				} catch( error: any ) {
					if( $mol_fail_catch( error ) ) {
						if( error.message ) $mol_fail_hidden( error )
						else $mol_fail_hidden( new Error( `Can't decrypt`, { cause: error } ) )
					}
				}
			} else {
				sand._open = sand._ball
			}
			
			return sand._open!
			
		}
		
		@ $mol_mem
		encryptable() {
			return !this._sand.size
		}
		
		@ $mol_mem
		encrypted( next?: boolean ) {
			
			$mol_wire_solid()
			
			const gift = this._gift.get( this.link().str )
			const prev = gift?.code_exists() ?? false
			
			if( next === undefined ) return prev
			
			if( this.faces.size ) {
				if( prev === next ) return prev
				$mol_fail( new Error( `Change encryption is forbidden` ) )
			}
			
			const auth = this.auth()
			
			const unit = $mol_wire_sync( $giper_baza_unit_gift ).make()
			$giper_baza_unit_trusted_grant( unit )
			
			unit.rank( $giper_baza_rank_rule )
			unit.time_tick( this.tick().time_tick )
			unit.lord( auth.pass().lord() )
			unit.mate( auth.pass().lord() )
			unit._land = this
			
			if( next ) {
				const secret = $mol_wire_sync( $mol_crypto_sacred ).make()
				const secret_mutual = auth.secret_mutual( auth.pass() )
				const secret_closed = $mol_wire_sync( secret_mutual ).close( secret, unit.salt() )
				unit.code().set( secret_closed )
			}
			
			this.diff_apply( [ auth.pass(), unit ] )
			
			return next
		}
		
		@ $mol_mem
		secret() {
			
			if( !this.encrypted() ) return null
			
			const auth = this.auth()
			const gift = this._gift.get( auth.pass().lord().str )
			if( !gift ) return $mol_fail( new Error( `Access denied` ) )
			
			if( !gift.code_exists() ) return $mol_fail( new Error( `No key to decrypt` ) )
			
			const secret_mutual = auth.secret_mutual( this.lord_pass( gift.lord() )! )
			if( !secret_mutual ) return $mol_fail( new Error( `Can't decrypt secret` ) )
			
			const salt = $mol_buffer.from( gift.salt().slice() ).mix( this.link().lord().toBin() )
			
			return new $mol_crypto_sacred( $mol_wire_sync( secret_mutual ).open( gift.code(), salt ).buffer )
			
		}
		
		dump() {
			
			this.units_saving()
			
			const units = [] as $giper_baza_unit_base[]
			
			for( const gift of this._gift.values() ) units.push( gift )
			
			for( const heads of this._sand.values() ) {
				for( const sands of heads.values() ) {
					for( const sand of sands.values() ) {
						units.push( sand )
					}
				}
			}
			
			return {
				land: this.link(),
				units
			}
			
		}
		
		;[ Symbol.for( 'nodejs.util.inspect.custom' ) ]() {
			return $mol_term_color.blue( '$giper_baza_land' )
				+ $mol_term_color.magenta( ` @` + this.link() )
		}
		
		;[ $mol_dev_format_head ]() {
			return $mol_dev_format_span( {},
		 		$mol_dev_format_native( this ),
				' ',
				$mol_dev_format_auto( this.faces.stat ),
		 	)
		 }
		
	}
	
}
